module.exports = __webpack_public_path__ + "static/media/Felipe.92d45443.jpg";